import React, { FunctionComponent } from 'react';
import { Modal, View, Text, Pressable, ViewStyle, Platform } from 'react-native';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import MaterialCommunityIcons from 'react-native-vector-icons/MaterialCommunityIcons';
import { DialogProps } from './Dialog.types';
import styles from './Dialog.styles';

export const Dialog: FunctionComponent<DialogProps> = ({
  visible,
  onClose,
  title,
  children,
  showCloseButton = true,
  animationType = 'fade',
  transparent = true,  
  fullScreen = false,
  width,
  fitContent = false,
}) => {
  const insets = useSafeAreaInsets();

  const containerWidth: ViewStyle = width ? {width} : {};
  // Sur iOS, le Modal s'affiche toujours plein écran, statusbar comprise : il faut
  // donc toujours réserver insets.top/bottom, que le dialog soit fullScreen ou centré,
  // sinon le contenu (ou le fond assombri) peut passer sous/au-dessus de la statusbar.
  // Sur Android, le Modal (statusBarTranslucent=false par défaut) est déjà positionné
  // sous la statusbar : ajouter insets.top y créerait un espace en trop.
  const backdropPaddingTop = Platform.OS === 'ios' ? Math.max(insets.top, 12) : 12;
  const backdropPaddingBottom = Platform.OS === 'ios' ? Math.max(insets.bottom, 12) : 12;
  const backdropPaddingHorizontal = 12;

  return (
    <Modal
      animationType={animationType}
      transparent={transparent}
      visible={visible}
      onRequestClose={onClose}
      statusBarTranslucent={false}
    >
      <View style={[styles.backdrop, fullScreen && styles.fullScreenBackdrop, { paddingBottom: backdropPaddingBottom, paddingTop: backdropPaddingTop, paddingHorizontal: backdropPaddingHorizontal }]} testID='BT_MODAL_BACKGROUND'>
        <View 
          style={[
            styles.container,
            fullScreen && styles.fullScreenContainer,
            containerWidth
          ]}
          testID='BT_MODAL_CONTENT'
        >
          {/* Header */}
          {(title || showCloseButton) && (
            <View style={styles.header}>
              {title && (
                <Text style={styles.title} numberOfLines={2}>
                  {title}
                </Text>
              )}
              {showCloseButton && onClose && (
                <Pressable
                  onPress={onClose}
                  style={styles.closeButton}
                  testID='BT_MODAL_EXIT'
                >
                  <MaterialCommunityIcons 
                    name="close" 
                    size={24} 
                    color="#666" 
                  />
                </Pressable>
              )}
            </View>
          )}

          {/* Content */}
          <View style={[styles.content, fitContent ? styles.contentFit : styles.contentFill]}>
            {children}
          </View>
        </View>
      </View>
    </Modal>
  );
};

export default Dialog;